<template>
  <div>
    <div class="row pl-3 pr-3 pt-0 mt-0">
      <div class="col-12 col-md-3">
        <dg-select-field
            :control="control"
            defaultValue="callere164"
            :field_span="22"
            :label_span="22"
            :options="filterbyOptions"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="filterByOptionsUpdated"
            field_mark=""
            label="Search By"
            name=""
            placeholder=""
            rules=""></dg-select-field>
      </div>
      <div class="col-12 col-md-3 pt-4">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="Search Value"></dg-text-field>
      </div>
      <div class="col-12 col-md-6 pt-4">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <el-table :data="tableData" border cell-class-name="p-1" stripe style="width: 100%" max-height="650">
      <!--<el-table-column v-for="(col, key) in dataKeys" :key="key"
          :label="col"
          :prop="col"
           width="160">
      </el-table-column>-->
      <el-table-column label="Start Time">
        <template slot-scope="scope">
          {{timestampToDate(scope.row.starttime)}}
        </template>
      </el-table-column>
      <el-table-column label="Caller" prop="callere164"></el-table-column>
      <el-table-column label="Destination" prop="calleee164"></el-table-column>
      <el-table-column label="Duration" prop="feetime"></el-table-column>

      <el-table-column label="Customer General" prop="callergatewayid"></el-table-column>
      <el-table-column label="Supplier Clearing" prop="calleegatewayid" v-if="isUserRootOrAdminGL"></el-table-column>
      <el-table-column label="Caller IP" prop="callerip" v-if="isUserRoot"></el-table-column>
    </el-table>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import module from './../index.js'
import {notify} from '@/system-services/notify.js'
import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
  },
  props: {
    useUserVos: {
      required: true
    },
    vosId: {
      required: true
    },
    cdrDate: {
      required: true
    }
  },
  data() {
    return {
      filterbyOptions: [
          {label: 'Caller', value: 'callere164'},
          {label: 'Destination', value: 'calleee164'},
          {label: 'Duration', value: 'feetime'},
          {label: 'Customer General', value: 'callergatewayid'},
      ],
      selectedFilterProperty: 'callere164',
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserRootOrAdminGL: $store.getters['user-state/isUserRoot'] || $store.getters['user-state/isUserAdminGL'],
      dataKeys: [],
      tableData: [],
      userVOSType: -1,
      selectedVosId: false,
      vosCdrDialog: false,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 32,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,

    };
  },
  beforeMount() {
    if (this.isUserRootOrAdminGL) {
      this.filterbyOptions.push({
        label: 'Supplier Clearing',
        value: 'calleegatewayid'
      })
    }

    if (this.isUserRoot) {
      this.filterbyOptions.push({
        label: 'Caller IP',
        value: 'callerip'
      })
    }

    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    filterByOptionsUpdated (inputField) {
      let val = inputField.field.field_value
      this.selectedFilterProperty = val
    },
    timestampToDate (timestamp) {
      let d = new Date(parseInt(timestamp));
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()  + ' ' + d.getHours() + ':' +  d.getMinutes() + ':' +  d.getSeconds()

    },
    viewCDR (params) {
      let vosId = params.data.id
      this.vosCdrDialog = true
      this.selectedVosId = vosId
    },
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    getEntityListData(page) {
      if ($store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller']) this.userVOSType = 0
      if ($store.getters['user-state/isUserGenerateLive']) this.userVOSType = 2
      let userVOSType = (this.useUserVos != null || this.useUserVos != -1)? this.userVOSType : ''
      let username = (this.useUserVos)? $store.state['user-state'].profile.username : ''
      let vosServerId = this.vosId

      this.getEntityList({
        page,
        userVOSType,
        username,
        vosServerId,
        cdrDate: this.cdrDate,
        search: this.userSearch,
        filterProperty: this.selectedFilterProperty,
      }).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.tableData = response.rows
      this.recordsCounter = response.count
      /*if (response.count > 0) {
        let t = this.tableData[0]
        this.dataKeys = Object.keys(t)
      }*/
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions(module.info.name + '-api', {getEntityList: 'listVOSCdr', updateEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
      /*this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })*/
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.rowData)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
